import '@vaadin/text-area';
import { componentName, TextAreaClass } from './TextAreaClass';

customElements.define(componentName, TextAreaClass);

export { TextAreaClass, componentName };
